<!--
  Componente de redirecionamento externo para a Comunidade.
  Quando o usuário clica em "Comunidade" na sidebar, o Vue Router
  navega para esta rota. O componente abre a URL configurada (COMMUNITY_URL)
  em nova aba e volta automaticamente para a rota anterior.

  A URL vem de window.globalConfig.COMMUNITY_URL (exposta pelo Rails
  no dashboard_controller.rb via app_config - step 80 do build).

  Módulo: chatwoot-pipeline - Comunidade
-->
<script>
export default {
  name: 'CommunityExternalRedirect',
  mounted() {
    const url =
      (window.globalConfig && window.globalConfig.COMMUNITY_URL) || '';

    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }

    // Sempre voltar para a rota anterior (ou dashboard home como fallback)
    // usando setTimeout para não competir com a navegação atual do router
    setTimeout(() => {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.replace({
          name: 'home',
          params: { accountId: this.$route.params.accountId },
        });
      }
    }, 50);
  },
  render() {
    return null;
  },
};
</script>
